<div class="container">
  <div class="head">
    <div mat-dialog-title class="head-label">
      Edit modifier group type
    </div>
  </div>

  <div>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <mat-form-field class="name" appearance="fill">
          <mat-label>Type name</mat-label>
          <input matInput type="text" formControlName="typeName">
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Adding type</mat-label>
          <mat-select formControlName="addingType">
            <mat-option *ngFor="let addingType of addingTypes; index as i" [value]="addingType">{{addingType}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Visual type</mat-label>
          <mat-select formControlName="visualType">
            <div *ngIf="this.form.value[ 'addingType' ] === addingTypes[0]">
              <mat-option  *ngFor="let visualType of visualTypesForAddon; index as i" [value]="visualType">{{visualType}}</mat-option>
            </div>
            <div *ngIf="this.form.value[ 'addingType' ] === addingTypes[1]">
              <mat-option  *ngFor="let visualType of visualTypesForRemovals; index as i" [value]="visualType">{{visualType}}</mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-bottom" style="display: flex">
        <button
          class="button"
          mat-button
          type="submit"
          (submit)="submit()"
          style="flex: auto"
        >{{ 'MENU.SAVE' | translate }}
        </button>

        <button
          mat-button
          type="button"
          (click)="delete()"
          style="flex: auto"
        >{{ 'MENU.DELETE' | translate }}
        </button>
      </div>
    </form>
  </div>

</div>
